import React from 'react';
import { MailList } from '../components/MailList';
import { NavigationMenu } from '../components/NavigationMenu';
import { PageHeader } from '../components/PageHeader';

export const Mail: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-slate-800 dark:to-gray-900 transition-colors duration-200 mobile-content-padding overflow-x-hidden">
      {/* Навигационное меню для десктопа */}
      <div className="hidden lg:block">
        <NavigationMenu />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <PageHeader
          title="Почта"
          subtitle="Безопасный обмен документами и управление доступом с другими пользователями платформы"
        />

        {/* Основное содержимое */}
        <div className="w-full max-w-5xl mx-auto">
          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 dark:border-gray-700/50 overflow-hidden">
            <MailList />
          </div>
        </div>
      </div>
    </div>
  );
}; 